import {icons} from '../helpers/google'


let advancedMarkerElementPromise = null

async function getAdvancedMarkerElement() {
  if (!advancedMarkerElementPromise) {
    advancedMarkerElementPromise = window.google.maps.importLibrary('marker').then(lib => lib.AdvancedMarkerElement)
  }
  return advancedMarkerElementPromise
}


export const defaultIconSize = {
  width: window.innerWidth <= 800 ? 30 : 35,
  height: (window.innerWidth <= 800 ? 30 : 35) * 316 / 273
}


function calculateZIndex(type, isPremier) {
  return isPremier ? window.google.maps.Marker.MAX_ZINDEX + 10 : 5
}


function getImageURLOfPremierVenue(data) {
  return data?.attributes?.imageDerivatives?.small
}


/**
 * Creates an AdvancedMarkerElement using the new API.
 * It builds a DOM element containing an <img> whose src is the marker icon.
 */
export async function createMapMarker(map, coordinates, type, data, setMap = true) {
  const AdvancedMarkerElement = await getAdvancedMarkerElement()
  
  const isPremier = data?.attributes?.isPremier
  const zIndex = calculateZIndex(type, isPremier)
  const baseUrl = isPremier ? icons.premierVenue : icons[type]
  const overlayUrl = isPremier ? getImageURLOfPremierVenue(data) : null
  
  const {width, height} = defaultIconSize
  
  // Create a container element for the marker.
  const markerDiv = document.createElement('div')
  markerDiv.style.width = `${width}px`
  markerDiv.style.height = `${height}px`
  markerDiv.style.position = 'relative'
  markerDiv.style.transition = 'transform 0.2s ease-out'
  markerDiv.style.transformOrigin = 'top center'

  // Add the pop class for the animation.
  markerDiv.classList.add('pop')
  markerDiv.addEventListener('animationend', () => {
    markerDiv.classList.remove('pop')
  })
  
  // Create an <img> for the base marker.
  const baseImg = document.createElement('img')
  baseImg.src = baseUrl
  baseImg.style.width = '100%'
  baseImg.style.height = '100%'
  baseImg.style.objectFit = 'contain'
  markerDiv.appendChild(baseImg)
  
  // If there is an overlay image, add it as another <img>.
  if (overlayUrl) {
    const overlayImg = document.createElement('img')
    overlayImg.src = overlayUrl
    // Position the overlay image on top of the base.
    overlayImg.style.position = 'absolute'
    // For example, set width to 60% of the container and center it horizontally.
    overlayImg.style.width = `${width * 0.9}px`
    overlayImg.style.height = `${width * 0.9}px` // or adjust for aspect ratio
    overlayImg.style.top = `${width * 0.1 / 2}px`
    overlayImg.style.left = `${width * 0.1 / 2}px`
    overlayImg.style.objectFit = 'cover'
    overlayImg.style.borderRadius = '50%'
    markerDiv.appendChild(overlayImg)
  }
  
  // Create the AdvancedMarkerElement with our custom DOM element.
  const advancedMarker = new AdvancedMarkerElement({
    map: setMap ? map : null,
    zIndex,
    content: markerDiv,
    position: coordinates,
    gmpDraggable: false,
    gmpClickable: true
  })
  
  advancedMarker.data = data
  return advancedMarker
}




